import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { NotificationOutput } from '../model/notification.output';

export interface RequestMeetingInput {
	readonly coachId: string;
	readonly endTimestamp: number;
	readonly startTimestamp: number;
}

export interface RequestMeetingParams {
	input: RequestMeetingInput;
}

@Injectable({ providedIn: 'root' })
export class RequestMeetingApiMutation extends ApiMutation<
	NotificationOutput,
	RequestMeetingParams
> {
	client = 'messaging';
	document = gql`
		mutation RequestMeeting($input: RequestMeetingInput!) {
			requestMeeting(input: $input) {
				id
				type
				taskId
				documentId
				orgModuleId
				sourceUserId
				targetUserId
				contactsName
				updateTimestamp
				creationDateTime
				meeting {
					coachId
					endDate
					startDate
				}
			}
		}
	`;
	method = 'requestMeeting';
}
